import { IGif } from '@giphy/js-types'
import React, { useContext } from 'react'
import ModalContext from 'shared/components/context/modal'
import { useCanAddGifToCollection } from 'shared/hooks/use-permissions'
import styled from 'styled-components'

const Container = styled.div`
    cursor: pointer;
    display: block;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-content: center;
    padding: 6px 10px;
    .ss-plus {
        margin-right: 19px;
    }
`
const GifDetailAddToCollection = ({ gif }: { gif: IGif }) => {
    const { openGifEditPanel } = useContext(ModalContext)
    const canAddToCollection = useCanAddGifToCollection(gif.id)
    return canAddToCollection ? (
        <Container onClick={() => openGifEditPanel(gif, 'Collections')}>
            <div className="ss-plus" />
            Add to Collection
        </Container>
    ) : null
}
export default GifDetailAddToCollection
